interface IRefreshTokenResponse {
  errors?: object
  access_token?: string
  refresh_token?: string
}

/**
 * Refreshes the current access token using the refresh token
 *
 * @param apiUrl The API URL to call for token refresh
 * @param token The refresh token to use
 * @returns Promise with the new access token and refresh token
 */
export const refreshCurrentAccessToken = (
  apiUrl: string,
  token: string
): Promise<IRefreshTokenResponse> => {
  // Make sure we have a token to send
  if (!token) {
    console.log('Error: No refresh token provided to refreshCurrentAccessToken')
    return Promise.reject(new Error('No refresh token provided'))
  }

  // Log the API URL we're using (without showing the full token)
  console.log(`Refreshing token at ${apiUrl}/auth/token with refresh token`)

  return fetch(`${apiUrl}/auth/token`, {
    body: JSON.stringify({ refreshToken: token, grantType: 'refresh' }),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) {
        console.log(`Error refreshing token: HTTP ${response.status}`)
        throw new Error(`Failed to refresh token: ${response.statusText}`)
      }
      return response.json()
    })
    .then((data) => {
      // Validate the response data
      if (!data.access_token || !data.refresh_token) {
        console.log('Error: Invalid token response data', data)
        throw new Error(
          'Invalid token response: Missing access or refresh token'
        )
      }

      // Return the tokens
      return {
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        errors: data.errors,
      }
    })
    .catch((error) => {
      console.log('Token refresh failed:', error.message)
      throw error
    })
}
